"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const TaskPage_1 = require("../../base/TaskPage");
const NumericInput_1 = require("../../../../view/components/input/numeric/NumericInput");
const autosave_1 = require("../../../../hooks/autosave");
const Paragraph_1 = require("../../../../view/components/paragraph/Paragraph");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const RadioQuestion_1 = require("../../../components/input/radio/RadioQuestion");
const HelpLink_1 = require("../../../components/help-link/HelpLink");
const cleaningFeeRestriction = 'cleaning fee';
const newCleaningFee = (propertyId, charge) => {
    return {
        restriction_type: cleaningFeeRestriction,
        allowed: true,
        charge_type: 'fixed',
        property: propertyId,
        charge
    };
};
exports.default = (props) => {
    const { property, viewState, update, lastSaved, updaterError, getterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [hasCleaningFee, setHasCleaningFee] = React.useState(false);
    const [cleaningFeeValue, setCleaningFeeValue] = React.useState(0);
    React.useEffect(() => {
        const currentFee = property === null || property === void 0 ? void 0 : property.restrictions.find((res) => res.restriction_type === cleaningFeeRestriction);
        if (currentFee)
            setHasCleaningFee(true);
        if (cleaningFeeValue !== (currentFee === null || currentFee === void 0 ? void 0 : currentFee.charge)) {
            setCleaningFeeValue(currentFee === null || currentFee === void 0 ? void 0 : currentFee.charge);
        }
    }, [property === null || property === void 0 ? void 0 : property.restrictions]);
    return React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.CLEANING_FEE, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement("div", { "data-testid": "cleaning-fee-page" },
                        React.createElement(Heading_1.HeadingSmall, null, "Cleaning fee"),
                        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                        React.createElement(RadioQuestion_1.YesNoRadioQuestion, { id: "cleaning-fee-yes-no", question: "Do you charge guests a cleaning fee?", onChange: (_, value) => {
                                setHasCleaningFee(value);
                                if (value === true) {
                                    const cleaningFee = newCleaningFee(property === null || property === void 0 ? void 0 : property.id, 25);
                                    update({ restrictions: [...property === null || property === void 0 ? void 0 : property.restrictions, cleaningFee] });
                                }
                                else {
                                    update({ restrictions: property === null || property === void 0 ? void 0 : property.restrictions.filter((p) => p.restriction_type !== 'cleaning fee') });
                                }
                            }, selected: hasCleaningFee }),
                        hasCleaningFee && (React.createElement(React.Fragment, null,
                            React.createElement(Spacer_1.Spacer, null),
                            React.createElement(Paragraph_1.Paragraph, null, "Please note the 20% commission charge (5% Travelnest fee + 15% channel fee) applies to the cleaning fee."),
                            React.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                            React.createElement(HelpLink_1.HelpLink, { to: "https://travelnest.freshdesk.com/support/solutions/articles/101000365099-cleaning-fees" }, "Find out more here."),
                            React.createElement(Spacer_1.Spacer, null),
                            React.createElement(NumericInput_1.NumericInput, { label: "How much is your cleaning fee?", hintText: "This is charged per stay.", id: "cleaning-fee-input", value: cleaningFeeValue, handleChange: (charge) => {
                                    let cleaningFee;
                                    setCleaningFeeValue(charge);
                                    const existing = property === null || property === void 0 ? void 0 : property.restrictions.find((res) => res.restriction_type === cleaningFeeRestriction);
                                    if (existing) {
                                        cleaningFee = Object.assign(Object.assign({}, existing), { charge, allowed: true });
                                        update({
                                            restrictions: [
                                                ...((property === null || property === void 0 ? void 0 : property.restrictions) || []).filter((res) => res.restriction_type !== cleaningFeeRestriction),
                                                cleaningFee,
                                            ]
                                        });
                                    }
                                    else {
                                        cleaningFee = newCleaningFee(property === null || property === void 0 ? void 0 : property.id, charge);
                                        update({ restrictions: [...property === null || property === void 0 ? void 0 : property.restrictions, cleaningFee] });
                                    }
                                }, valid: cleaningFeeValue !== 0, errorMessage: "Cleaning fee cannot be 0." }))),
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'cleaning-fee', text: "We recommend incorporating your cleaning fee into your nightly price. If this isn't possible, try to keep your cleaning fee as low as possible." }))))));
};
//# sourceMappingURL=CleaningFeePage.js.map